import React from 'react';
import { Box, CardMedia, Container, Stack, Typography } from '@mui/material';
import { useDevice } from '../../hooks/useResponsive';
import GradientCTAButton from './InspectionButton';

const BookFromAnywere = () => {
  const { isMobile } = useDevice();

  return (
    <>
      <Container sx={{ pt: 9, pb: isMobile ? 20 : 13, px: isMobile ? 2 : 0.8, backgroundColor: 'white' }}>
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/book.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px' }}
        />
        <Stack pt={2} pb={3} pr={7} px={1.5}>
          <Typography mb={0.5} color="#000000" fontSize="24px" fontWeight="800" lineHeight={1.2}>
            Book From Anywhere, <br />
            Inspect Right There!{' '}
          </Typography>
          <Typography fontSize="11px" color="#000000" fontWeight="400">
            Book FOCUS Inspection Service and get your chosen car thoroughly inspected by certified experts—complete
            with warranty assurance.
          </Typography>
          <Box mt={2}>
            <Typography color="#000000" fontSize="11px">
              📱 Easy online booking from your phone
            </Typography>
            <Typography color="#000000" fontSize="11px">
              📍 Inspection at car’s exact location
            </Typography>
            <Typography color="#000000" fontSize="11px">
              🎯 Precisely track your inspection status in real-time
            </Typography>
          </Box>
        </Stack>
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/notePad.webp"
          alt="Card Image"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px', mb: 4 }}
        />
        <GradientCTAButton text="Get Warranty Assurance" />
      </Container>
    </>
  );
};

export default BookFromAnywere;
